import * as React from "react";
import { List, Datagrid, TextField } from "react-admin";

// L'endpoint /pro/traits-hobbies retourne un DTO unique
// { traits: string[], hobbies: string[], jobs: string[], about }.
// Le dataProvider l'aplatit en [{ id, kind, name }] via transformList
// (cf. src/api/resourceMap.js). Donc lecture seule, pas de CRUD individuel.
export default {
  list: () => (
    <List perPage={100} pagination={false} title="Traits & loisirs">
      <Datagrid bulkActionButtons={false}>
        <TextField source="kind" label="Type" />
        <TextField source="name" label="Valeur" />
      </Datagrid>
    </List>
  ),
};
